import { Breakpoint, Theme, useMediaQuery } from '@mui/material';

const useThemeBreakpoints = (dir: keyof Theme['breakpoints'], breakpoint: Breakpoint | number) => {
  const match = useMediaQuery<Theme>((theme) => (theme.breakpoints[dir] as Function)(breakpoint));

  return match;
};

export default useThemeBreakpoints;
